export const areLengthsEqual = (array1: any[], array2: any[]): boolean => {
  return array1.length == array2.length;
};